import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SEARCH_FEATURE_KEY, SearchState } from './search.reducer';
import { SearchTarget } from '@cpak/adp-cpak-bff-service-models';

export const getSearchState = createFeatureSelector<SearchState>(SEARCH_FEATURE_KEY);
// eslint-disable-next-line
export const getSortingStateForTarget = (target: SearchTarget) =>
  createSelector(getSearchState, (state: SearchState) => state[target]);
